import Notify from "devextreme/ui/notify";

export const toastMsg = (msg, isSuccess) => {
  Notify(
    {
      message: msg,
      height: 45,
      width: "100%",
      minWidth: 150,
      type: isSuccess ? "success" : "info",
      displayTime: 3500,
      animation: {
        show: {
          type: "fade",
          duration: 400,
          from: 0,
          to: 1,
        },
        hide: { type: "fade", duration: 40, to: 0 },
      },
    },
    {
      position: "bottom left",
      direction: "up-push",
    }
  );
};
